export enum Page {
	UNKNOWN = 0,
	HOME = 1,
	LOGIN = 2,
	LOGOUT = 3,
	REGISTER = 4,
	ACTIVATE = 5,
	FORGOT_PASSWORD = 6,
	DASHBOARD = 7,
	JOBS = 8,
	JOB = 9,
	PROFILE = 10,
	DIRECTORY_JOB = 11,
	APPLICANTS = 12,
	INVITE = 13,
	TEAM = 14
}

export namespace Page {
	enum Description {
		UNKNOWN = "",
		HOME = "",
		LOGIN = "/login",
		LOGOUT = "/logout",
		REGISTER = "/register",
		ACTIVATE = "/activate",
		FORGOT_PASSWORD = "/forgot-password",
		DASHBOARD = "/dashboard",
		JOBS = "/jobs",
		JOB = "/job/{id}",
		PROFILE = "/profile",
		DIRECTORY_JOB = "/directory/job/{id}",
		APPLICANTS = "/job/{id}/applicants",
		INVITE = "/invite",
		TEAM = "/team"
	}

	export function getDescription(value: Page): string {
		switch (value) {
			case Page.HOME:
				return Description.HOME;
			case Page.LOGIN:
				return Description.LOGIN;
			case Page.LOGOUT:
				return Description.LOGOUT;
			case Page.REGISTER:
				return Description.REGISTER;
			case Page.ACTIVATE:
				return Description.ACTIVATE;
			case Page.FORGOT_PASSWORD:
				return Description.FORGOT_PASSWORD;
			case Page.DASHBOARD:
				return Description.DASHBOARD;
			case Page.JOBS:
				return Description.JOBS;
			case Page.JOB:
				return Description.JOB;
			case Page.PROFILE:
				return Description.PROFILE;
			case Page.DIRECTORY_JOB:
				return Description.DIRECTORY_JOB;
			case Page.APPLICANTS:
				return Description.APPLICANTS;
			case Page.INVITE:
				return Description.INVITE;
			case Page.TEAM:
				return Description.TEAM;
			case Page.UNKNOWN:
			default:
				return Description.UNKNOWN;
		}
	}
}